import React from 'react';
import { EDLogo } from './EDLogo';
import { Instagram, Facebook, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ed-darker py-12 border-t border-zinc-900" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12" data-id="element-185">
          <div className="md:col-span-2" data-id="element-186">
            <EDLogo className="mb-6" data-id="element-187" />
            <p className="text-zinc-500 text-sm max-w-sm font-medium leading-relaxed" data-id="element-188">
              Formación profesional en instalaciones eléctricas domiciliarias.
              Aprendé desde cero con criterio técnico, normativa vigente y
              acompañamiento real.
            </p>
          </div>

          <div data-id="element-189">
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-4" data-id="element-190">
              Programa
            </h4>
            <ul className="space-y-3" data-id="element-191">
              <li data-id="element-192">
                <a href="#" className="text-zinc-500 hover:text-ed-green transition-colors text-sm font-medium" data-id="element-193">
                  Módulo 1: Fundamentos
                </a>
              </li>
              <li data-id="element-194">
                <a href="#" className="text-zinc-500 hover:text-ed-green transition-colors text-sm font-medium" data-id="element-195">
                  Módulo 2: Montaje
                </a>
              </li>
              <li data-id="element-196">
                <a href="#" className="text-zinc-500 hover:text-ed-green transition-colors text-sm font-medium" data-id="element-197">
                  Módulo 3: Instalación
                </a>
              </li>
              <li data-id="element-198">
                <a href="#" className="text-zinc-500 hover:text-ed-green transition-colors text-sm font-medium" data-id="element-199">
                  Clases en vivo
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-200">
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-4" data-id="element-201">
              Contacto
            </h4>
            <div className="flex gap-4 mb-6" data-id="element-202">
              <a href="#" className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:bg-ed-green hover:text-ed-black transition-all" data-id="element-203">
                <MessageCircle className="w-5 h-5" data-id="element-204" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:bg-ed-green hover:text-ed-black transition-all" data-id="element-205">
                <Instagram className="w-5 h-5" data-id="element-206" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:bg-ed-green hover:text-ed-black transition-all" data-id="element-207">
                <Facebook className="w-5 h-5" data-id="element-208" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-zinc-900 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-209">
          <p className="text-zinc-600 text-xs font-medium" data-id="element-210">
            &copy; {new Date().getFullYear()} ED Academia. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6 text-xs font-medium text-zinc-600" data-id="element-211">
            <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-212">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-213">
              Políticas de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}